import React from 'react';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/system';
import { useMediaQuery } from '@mui/material';
import { useContainerQuery } from '../../hooks/useContainerQuery';
import { SCOPE_ID } from '../handlers/DomHandler';

// A thin wrapper that only handles fullScreen and scroll lock,
// letting UiScope control the default container globally.
export default function ScopableDialog({
  open,
  onClose,
  fullScreen: fullScreenControlled,
  enableScoping, // if true, we use container-query-based fullscreen and disableScrollLock
  children,
  ...props
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallContainer = useContainerQuery(
    theme.containerQueries(SCOPE_ID).down('sm'),
  );

  // If scoping is enabled, determine fullScreen by container query; otherwise by viewport
  const autoFullScreen = enableScoping ? isSmallContainer : isSmallScreen;
  const fullScreen =
    fullScreenControlled || (autoFullScreen ? true : undefined);

  // You can still override container per instance if needed:
  // const { portalContainer } = useUiScope();
  // const container = React.useCallback(() => (enableScoping ? portalContainer : undefined), [enableScoping, portalContainer]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      // container={enableScoping ? container : undefined} // usually not needed; UiScope sets defaults
      disableScrollLock={enableScoping || undefined}
      fullScreen={fullScreen}
      {...props}
      slotProps={{
        paper: {
          sx:
            fullScreen && enableScoping
              ? {
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  m: 0,
                  borderRadius: 0,
                  ...(props?.PaperProps?.sx || {}),
                }
              : props?.PaperProps?.sx,
        },
      }}
    >
      {children}
    </Dialog>
  );
}
